import React from 'react';
import PropTypes from 'prop-types';
import { LocalizedLink as Link } from 'gatsby-plugin-i18n-l10n';
import Line from './Line';
import Section from './Section';
import RoundedBox from './RoundedBox';


export default function Claim(props) {
    const {
        children, link, className, subtitle, title,
    } = props;

    const titleElement = title && (
        <h2 className="text-left font-bold !text-certego-white">
            {title}
        </h2>
    );

    const subtitleElement = subtitle && (
        <h4 className="text-left !text-certego-white">
            {subtitle}
        </h4>
    );

    return (
        <Section>
            <RoundedBox className={className}>
                <Line />
                <div className="sm:flex mx-6 justify-between items-end">
                    <div>
                        {title && link ? (
                            <Link to={link} className="text-4xl hover:underline">
                                {titleElement}
                            </Link>
                        ) : titleElement}
                        {subtitleElement}
                        {children}
                    </div>
                    {link
                        && (
                        <Link to={link} className="text-4xl hover:bg-certego-blue">
                            ⇢
                        </Link>
                        )}
                </div>
                <Line color="certego-blue" width={2} className="w-2/3" />
            </RoundedBox>
        </Section>
    );
}

Claim.defaultProps = {
    children: undefined,
    className: null,
    link: null,
    subtitle: null,
    title: null,
};

Claim.propTypes = {
    children: PropTypes.node,
    className: PropTypes.string,
    link: PropTypes.string,
    subtitle: PropTypes.node,
    title: PropTypes.node,
};
